<script setup lang="ts">
withDefaults(defineProps<{
  variant?: 'default' | 'inverted' | 'outline'
}>(), {
  variant: 'default',
})
</script>

<template>
  <span
    class="inline-block font-display uppercase text-eyebrow rounded-pill px-2 py-1"
    :class="{
      'bg-brand-yellow text-brand-ink': variant === 'default',
      'bg-brand-ink text-brand-yellow': variant === 'inverted',
      'bg-transparent text-brand-ink ring-1 ring-inset ring-brand-ink': variant === 'outline',
    }"
  >
    <slot/>
  </span>
</template>
